import {
  GET_PROBLEMS,
  PROBLEM_ERROR,
  GET_PROBLEM,
  CLEAR_PROBLEM,
} from "./types";
import axios from "axios";

export const getProblems = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/problems");

    dispatch({
      type: GET_PROBLEMS,
      payload: res.data,
    });
    dispatch({
      type: CLEAR_PROBLEM,
    });
  } catch (err) {
    dispatch({
      type: PROBLEM_ERROR,
      payload: { msg: "Error" },
    });
  }
};

export const getProblem = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/problems/${id}`);

    dispatch({
      type: GET_PROBLEM,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROBLEM_ERROR,
      payload: { msg: "Error" },
    });
  }
};
